import styled from 'styled-components';

import { FileTypeIcon } from '@/shared/components/FileTypeIcon';
import { BFC } from '@/shared/types';

type FieldFileProps = {
  data: {
    name: string;
    extension: string;
  };
};

export const FieldFile: BFC<FieldFileProps> = ({ data, ...props }) => {
  return (
    <Container {...props}>
      <FileTypeIcon style={{ opacity: 0.5 }} ext={data.extension.replace('.', '')} size="s20" />
      <span className="lineclamp2">{data.name}</span>
    </Container>
  );
};

const Container = styled.div`
  max-width: 300px;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 100%;
`;
